<template>
	<div class="aside-wrap">
		<div class="aside-title">
			<div class="title-l">
				<div class="title-icon">
					<img src="@/assets/active_icon.png" />
				</div>
				<h3>月度活跃专家</h3>
			</div>
		</div>
		<div class="aside-content">
			<div class="card-list" v-for="item in dataList" :key="item.id">
				<div class="userinfo">
					<div class="userinfo-l">
						<img :src="item.headPic?item.headPic:require('@/assets/default-avatar.png')"/>
					</div>
					<div class="userinfo-r">
						<div class="username-wrap">
							<div class="username">{{item.nickName}}</div>
							<!-- <div class="user-tags">资讯规划 | 业务洞察</div> -->
						</div>
						<div class="userinfo-tips">
							<span>{{item.fansNum}}人已关注</span>
							<span>活动天数{{item.dayNum}}</span>
						</div>
					</div>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	import { post,ajaxParam } from '@/units/request.js'
	export default {
		name: 'asideActive',
		components: {
		},
		data(){
			return {
				pageNum: 1,
				pageSize: 8,
				dataList: [],
				userId: ''
			}
		},
		created(){
			this.getDataList()
		},
		methods: {
			//获取数据列表
			async getDataList(){
				let param = {
					userId: this.userId,
					pageSize: this.pageSize
				}
				ajaxParam(param)
				const res = await post('v1/index/activeUser', qs.stringify(param))
				if(res.data.code==200){
					this.dataList = res.data.list
				} else {
					this.$message.error(res.data.msg)
				}
			}
		}
	}
</script>

<style scoped lang="less">
	@import './common.less';
	.title-icon{
		background: #276BFD;
	}
	.aside-content {
		padding: 20px;
		.card-list{
			font-size: 12px;
			.userinfo-r{
				flex: 1;
				.username-wrap{
					display: flex;
					justify-content: space-between;
				}
			}
		}
	}
</style>
